import React from "react";
import {Flex} from "antd";
import {Fade} from "react-awesome-reveal";


// пример картинок
import alikhan_found from './alikhan_foundation.jpg';
import asan_mba from './asan_mba.jpg';
import mansur_found from './mansur_foundation.jpg';
import erkin_found from './erkin_foundation.jpg';
import arina_mom_foundation from './arina_mom_foundation.jpg';
import dariya_foundation from './dariya_foundation.jpg';
import {useWindowSize} from "@uidotdev/usehooks";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import {Masonry} from "@mui/lab";
import IntlMessage from "../../components/IntlMessage/IntlMessage";


// общая карточка отзыва
const ReviewCard = ({r}) => (
    <div style={styles.card}>
        <div style={styles.photo}>
            <img src={r.image} alt={r.name} style={styles.img}/>
        </div>
        <div style={styles.fullname}>{r.name}</div>
        <div style={styles.course}>{r.course}</div>
        <div style={styles.commentBox}>
            <div style={styles.commentLabel}><IntlMessage id={"reviewComment"}/></div>
            <div style={styles.commentText}>{r.comment}</div>
        </div>
    </div>
);

const reviews = [
    {
        image: asan_mba,
        name: "Ахметжан Асан",
        course: "МВА",
        comment:
            "Я прошел обучение по программе МВА «Финансовая технология и цифровая трансформация бизнеса» Astana IT university. И все дисциплины этого курса крепко засели в моей голове. От «Emotional intelligence», и до «Эконометрики в Python». И если ранее даже знания и были у меня, но я находил им применение по наитию. А уже пройдя полный курс обучения, я научился систематизировать все эти знания и правильно и к месту их применять. Считаю, что сейчас, для того, чтобы оставаться «на волне», просто жизненнно необходимо постоянно учиться. На любом уровне. Это повышает твою востребованность на рынке труда."
    },
    {
        image: dariya_foundation,
        name: "Шарипкали Дария",
        course: "Foundation",
        comment:
            "Программа AITU Foundation помогла мне за год значительно улучшить свои знания. Помимо подготовки к ЕНТ, я подтянула английский, развила навыки презентации и научилась эффективно работать в команде.  \n" +
            "Особенно ценным для меня был подход преподавателей — они доступно объясняют материал, всегда готовы помочь и поддерживают не только академически, но и морально.  \n" +
            "Мне особенно понравились практические задания и атмосфера в группе. Учиться вместе с единомышленниками мотивировало двигаться вперёд и не останавливаться на достигнутом."
    },
    {
        image: alikhan_found,
        name: "Майлыбай Алихан",
        course: "Foundation",
        comment:
            "AITU Foundation бағдарламасы маған шынымен көп көмектесті. Осы бағдарлама арқылы ҰБТ-ға дайындалып жүріп, бұрын білмегенімді үйрендім. Сабақтар түсінікті де қызықты өтті. Әсіресе, ұстазымыз Бейбіт Мұқашұлы бәрін қарапайым тілмен жақсы түсіндіреді. Әр сұраққа сабырмен жауап беріп, қиын тақырыптарды да оңай қылып жеткізді. Соның арқасында дайындалу да жеңілдеп, білімім артты. Ғазиза апайға және Бейбіт ағайға алғысым шексіз!"
    },
    {
        image: erkin_found,
        name: "Еркін Альнұр",
        course: "Foundation",
        comment:
            "Я прошел 30-недельную программу Foundation от Astana IT University. В курсе изучались основы математики, информатики, веб-разработки (HTML, CSS, SQL, PHP, JS), а также темы по устройству компьютера и сетям.\n" +
            "\n" +
            "Материал был хорошо структурирован, обьяснялся понятно и с примерами. Особенно помогали практические задания, которые преподаватель лично проверял и давал обратную связь. Местами было немного трудно, но в целом все усваивалось благодаря хорошей подаче.\n" +
            "\n" +
            "Проекты не делали, но в конце были заключительные тесты. В процессе обучения я набирал уверенность в сфере IT, прокачал навыки работы с информацией и изучил много нового.\n" +
            "\n" +
            "Плюсы: интуитивно понятный интерфейс, четкий план, дисциплина и профессионализм преподавателя. Минус - ранние подьемы :)\n" +
            "\n" +
            "Настоятельно рекомендую курс тем, кто только начинает путь в IT или кто уже немного разбирается в этой сфере!"
    },
    {
        image: mansur_found,
        name: "Жумажанов Мансур",
        course: "Foundation",
        comment:
            "Прошел онлайн-курсы по информатике - очень понравилось. Материал подан понятно, с примерами и практическими заданиями. Особенно понравились темы по веб разработке и основам программирования. Платформа удобная, есть поддержка от преподавателей. Подойдет как новичкам, так и тем, кто хочет освежить знания"
    },
    {
        image: arina_mom_foundation,
        name: "Хазова Анастасия",
        course: "Foundation",
        comment:
            "Отзыв о прохождении курса Foundation дочерью Ариной (сентябрь 2024 – май–июнь 2025)\n" +
            "Моя дочь Арина успешно прошла курс Foundation при Astana IT University с сентября 2024 по май–июнь 2025 года. Хочу отметить ряд важных преимуществ:\n" +
            "\n" +
            "Превосходная организация обучения: чёткое расписание, заранее объявленные темы и удобный формат занятий.\n" +
            "\n" +
            "100 % обратная связь от преподавателей: они регулярно проводят диагностические, промежуточные и итоговые тесты, внимательно отслеживают прогресс учащихся и дают рекомендации.\n" +
            "\n" +
            "Практическая направленность и поддержка: программа ориентирована на подготовку к ЕНТ и вступительным экзаменам AITU, что позволяет выпускникам поступать без дополнительных вступительных испытаний.\n" +
            "\n" +
            "В целом, курс дал Арине уверенность в своих силах и существенно облегчал дальнейший путь к поступлению. Спасибо организаторам и преподавательскому составу за высокий профессионализм."
    }
];

const ReviewPage = () => {
    const size = useWindowSize();
    const isMobile = (size?.width ?? 0) < 700;

    return (
        <div>
            <Header/>

            <Flex style={styles.headWrap} align="center" justify="center" vertical>
                <Fade triggerOnce direction="down">
                    <h1 style={styles.head}><IntlMessage id={'reviewStudents'}/></h1>
                </Fade>
            </Flex>

            <div style={styles.container}>
                {isMobile ? (
                    <div style={{display: "grid", gridTemplateColumns: "1fr", gap: 16}}>
                        {reviews.map((r, i) => (
                            <Fade key={i} triggerOnce>
                                <ReviewCard r={r}/>
                            </Fade>
                        ))}
                    </div>
                ) : (
                    <Masonry columns={2} spacing={4}>
                        {reviews.map((r, i) => (
                            // <div key={i}>
                            <Fade key={i} triggerOnce>
                                <ReviewCard r={r}/>
                            </Fade>
                            // </div>
                        ))}
                    </Masonry>
                )}
            </div>

            <Footer/>
        </div>
    );
};

export default ReviewPage;

/* ====== стили ====== */
const styles = {
    headWrap: {padding: "120px 20px 0"},
    head: {margin: 0, fontSize: 48, lineHeight: 1.05, fontWeight: 800, textAlign: "center"},
    container: {maxWidth: 1440, margin: "24px auto 80px", padding: "0 20px"},
    card: {
        background: "#fff",
        borderRadius: 16,
        padding: 16,
        boxShadow: "0 1px 0 rgba(0,0,0,0.04), 0 6px 24px rgba(0,0,0,0.06)",
    },
    photo: {
        width: "100%",
        height: "auto",
        aspectRatio: "16 / 14", // даёт одинаковую ширину, а высота разная — красиво в Masonry
        overflow: "hidden",
        borderRadius: 12,
        marginBottom: 12,
    },
    img: {width: "100%", height: "100%", objectFit: "cover", display: "block", objectPosition: 'top'},
    fullname: {fontSize: 18, fontWeight: 700, marginTop: 4},
    course: {fontSize: 14, color: "#6b7280", marginTop: 2},
    commentBox: {background: "#F5F5F7", borderRadius: 12, padding: 14, marginTop: 12},
    commentLabel: {fontSize: 12, color: "#6b7280", marginBottom: 6},
    commentText: {fontSize: 15, lineHeight: 1.5, textAlign: "justify"},
};
